import(/* webpackMode: "eager" */ "/codebuild/output/src4172242104/src/helloero-new/packages/helloero/src/app/error.tsx");
